import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const API_BASE = (process.env.REACT_APP_BACKEND_URL || '') + '/api/customer/auth';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function CustomerAuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        toast.error('Login failed — no session found');
        navigate('/order/login');
        return;
      }

      const sessionId = match[1];

      try {
        const response = await fetch(`${API_BASE}/google-session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          const err = await response.json().catch(() => ({}));
          throw new Error(err.detail || 'Authentication failed');
        }

        const data = await response.json();
        const { token, customer } = data;

        // Store auth data
        localStorage.setItem('customer_token', token);
        localStorage.setItem('customer_user', JSON.stringify(customer));

        toast.success(`Welcome, ${customer.name || customer.email}!`);

        // Redirect: if phone not set, go to phone setup; else go to store selection
        if (customer.needs_phone) {
          window.location.href = '/order/setup-phone';
        } else {
          window.location.href = '/order';
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        toast.error(err.message || 'Login failed');
        navigate('/order/login');
      }
    };

    processSession();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#FFFDF9] flex items-center justify-center" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-3 border-[#D35400] border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-[#6C5D53] font-medium">Signing you in...</p>
      </div>
    </div>
  );
}
